import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { NAV, SITE } from "@/lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-warm-100 border-t border-warm-200/60 mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2 max-w-md">
          <Link to="/" className="flex items-center gap-3 mb-5">
            <img
              src={SITE.logo}
              alt={`${SITE.name} logo`}
              className="h-10 w-10 rounded-lg object-cover"
            />
            <span className="font-serif text-xl tracking-tight text-ink-900">{SITE.name}</span>
          </Link>
          <p className="text-ink-500 text-sm leading-relaxed">
            A Melbourne community services organisation helping people build the practical, social and
            emotional skills they need to live a better life — through cooking groups, outdoor activities, and counselling.
          </p>
          <div className="mt-5">
            <img
              src={SITE.ndisLogo}
              alt="We heart NDIS — Registered NDIS Provider"
              className="h-14 w-auto"
            />
          </div>
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest text-ink-400 mb-4">Explore</p>
          <ul className="space-y-2">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-sm text-ink-700 hover:text-brand transition-colors">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest text-ink-400 mb-4">Get in touch</p>
          <ul className="space-y-3 text-sm text-ink-700">
            <li className="flex items-start gap-2">
              <Phone className="w-4 h-4 mt-0.5 text-brand" />
              <a href={`tel:${SITE.phone.replace(/\s/g, "")}`} className="hover:text-brand">
                {SITE.phone}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="w-4 h-4 mt-0.5 text-brand" />
              <a href={`mailto:${SITE.email}`} className="hover:text-brand break-all">
                {SITE.email}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-0.5 text-brand" />
              <span>{SITE.address}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-warm-200/60">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-ink-400">
          <p>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
          <p className="font-serif italic">Skills for life.</p>
        </div>
      </div>
    </footer>
  );
}
